import * as React from 'react'

export default () => (
  <svg width='384' height='267' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)'>
      <path
        d='M406.616 261.516a1 1 0 0 1-.273 1.981l.273-1.981Zm-99.286-96.357-.05.999.05-.999Zm-98.138-1.997a1 1 0 0 1 1.379-.312l7.618 4.801a1 1 0 1 1-1.065 1.691l-6.772-4.268-4.264 6.764a1 1 0 0 1-1.693-1.067l4.797-7.609Zm197.151 100.335c-56.453-7.823-97.472-33.069-116.377-56.093-4.73-5.761-8.099-11.412-9.967-16.645-1.867-5.228-2.256-10.105-.923-14.257 2.711-8.439 12.202-13.158 28.304-12.341l-.1 1.997c-15.865-.806-24.027 3.884-26.299 10.957-1.157 3.605-.87 8.01.902 12.974 1.77 4.959 5.002 10.411 9.629 16.047 18.527 22.564 59.05 47.613 115.104 55.38l-.273 1.981Zm-98.963-99.336c10.256.52 17.115 2.935 21.019 6.717 3.977 3.852 4.716 8.946 3.134 14.299-1.57 5.311-5.431 10.956-10.786 16.211-5.367 5.267-12.29 10.2-20.079 14.072-15.556 7.735-34.724 11.31-51.927 4.641-17.257-6.69-32.265-23.577-39.678-56.185l1.951-.441c7.315 32.179 21.996 48.384 38.448 54.762 16.505 6.398 35.066 3.014 50.314-4.567 7.614-3.785 14.362-8.599 19.568-13.709 5.219-5.122 8.832-10.485 10.27-15.353 1.427-4.826.708-9.084-2.607-12.295-3.388-3.282-9.655-5.644-19.727-6.155l.1-1.997Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 0h384v267H0z' />
      </clipPath>
    </defs>
  </svg>
)
